/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Footer_Navlabel1Inputs */

const ja_playdata_footer_navlabel1 = /** @type {(inputs: Playdata_Footer_Navlabel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYDATA フッターナビゲーション`)
};

const en_playdata_footer_navlabel1 = /** @type {(inputs: Playdata_Footer_Navlabel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYDATA footer navigation`)
};

/**
* | output |
* | --- |
* | "PLAYDATA footer navigation" |
*
* @param {Playdata_Footer_Navlabel1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const playdata_footer_navlabel1 = /** @type {((inputs?: Playdata_Footer_Navlabel1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Footer_Navlabel1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_footer_navlabel1(inputs)
	return en_playdata_footer_navlabel1(inputs)
});
export { playdata_footer_navlabel1 as "playdata_footer_navLabel" }